import React, {useState} from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import {GetBirthDay, Currency} from '../Utils/Utils';
import moment from 'moment';
import IconAvatar from './IconAvatar';
import { Redirect } from "react-router-dom";

export default function Patient(props)
{
    const [viewac,setViewac] = useState(0);
    const [incog,SetIncog] = useState(props.EsIncognito>0);
    
    //Cuentas
    const objcuentas = props.cuentas;
    const cuentas = [];
    for(var c in objcuentas) {
        cuentas.push(objcuentas[c]);
     }
    const listcuentas = cuentas.map((cuenta, index) =>
    <div className="black hover_pointer" onClick={() => setViewac(cuenta.ID)} key={index}>
        <span><strong>{cuenta.EsParticular ? 'Part. = ': 'Seguro = '}</strong></span>
        <span><strong>{Currency.format(cuenta.Total)}</strong></span>
    </div>
    );
    //Facturas
    const objfacturas = props.cuentasfacturadas;
    const facturas = [];
    for(var f in objfacturas) {
        facturas.push(objfacturas[f]);
     }
    const listfacturas = facturas.map((factura) =>
    <div className="limegreen hover_pointer" onClick={() => setViewac(factura.ID)} key={factura.ID}>
        <span><strong>{factura.FolioFactura + ' = ' + Currency.format(factura.Total)}</strong></span>
    </div>
    );

    function SwitchIncognito()
    {
        if (props.EsIncognito>0)
        {
            SetIncog(!incog);
        }
    }

    if (viewac !== 0)
    {
        return(
            <Redirect
            to={{
            pathname: "/dashboard/cuenta/"+viewac}}/>
            );
    } else {
        return(
        <div>
            <Card className="m8 p4 bshadow">
                <Row>
                    <Col lg={4} md={4} sm={4} xs={12} className="gray">
                        <Row>
                            <Col lg={2} sm={12} xs={2}>
                                <IconAvatar age={GetBirthDay(props.Fecha_nacimiento)} Click={() => SwitchIncognito()}
                                            ism={props.Sexo === 'MASCULINO'} isincognito={props.EsIncognito}/>
                            </Col>
                            <Col lg={10} xs={10}>
                                <span style={incog?{color:'#ffffff'}:{color:'#000000'}}><strong>
                                {'#'+props.Expediente+'-'+props.Paterno+' '+props.Materno+' '+props.Nombre}
                                </strong></span><br/>
                                <span><strong>{props.Servicio_medico}</strong></span><br/>
                            </Col>
                        </Row>
                        <span className={props.Tipo===1?"blue":"orange"}>
                            <span><strong>Area: </strong></span>
                            <span>{props.Area}</span>
                            <span><strong> Habitacion: </strong></span>
                            <span>{props.Habitacion}</span><br/>
                        </span>
                        <span>Médico: </span>
                        <span>{props.Medico === "Dr. _________________________ Medico _______________________" 
                                ? 'Externo' : props.Medico}</span><br/>
                        <span>Motivo Ingreso: </span>
                        <span>{props.MotivoIngreso}</span>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={6} className="gray">
                        <span>{GetBirthDay(props.Fecha_nacimiento)}</span>
                        <span> Años, del </span>
                        <span>{moment(props.Fecha_nacimiento).format('DD/MM/YYYY')}</span><br/>
                        <span>Ubicación Actual: </span>
                        <span>{props.HabitacionActual}</span><br/>
                        <span>Fecha Ingreso </span>
                        <span>{moment(props.FechaIngreso).format('DD/MM/YYYY hh:mm a')}</span><br/>
                        <span>Estancia de </span>
                        <span>{moment().diff(props.FechaIngreso,"days")} dias, </span>
                        <span>{moment().diff(props.FechaIngreso,"hours")%24} horas y </span>
                        <span>{moment().diff(props.FechaIngreso,"minutes")%60} min. </span>
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={6}>
                        <Row>
                            <Col lg={6} md={12}>
                                {listcuentas}
                                <span><strong>Total = </strong></span>
                                <span><strong>{Currency.format(props.Total)}</strong></span><br/>
                                <span><strong>Abonos = </strong></span>
                                <span><strong>{Currency.format(props.Anticipos)}</strong></span><br/>
                                <span onClick={() => setViewac(props.cuentaId)} className="hover_pointer" 
                                        style={props.Adeudo>0?{color:'#d32f2f'}:{color:'#348e34'}} >
                                    <strong>Adeudo = </strong><strong>{Currency.format(props.Adeudo)}</strong>
                                </span>
                            </Col>
                            <Col lg={6} md={12}>
                                <span className="black"><strong>Facturas</strong></span><br/>
                                {listfacturas}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </div>
        );
    }
}
